var jquery = require('jquery');
module.exports = jquery.extend;
